import {component} from "bidello";
import { CSS3DRenderer } from 'three/examples/jsm/renderers/CSS3DRenderer'
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer'

import settings from "./settings";

class CSSRenderer extends component(CSS2DRenderer) {
    constructor() {
        super();
        this.domElement.style.position = 'absolute';
        this.domElement.style.top = 0;

    }

    onResize({ width, height }) {
        this.setSize(width, height);
    }
}

export default new CSSRenderer();